/** Marketing slug for the 30-minute program landing page */
export const LOP30_PROGRAM_SLUG = 'lop-30-minutter';

const frontendBase = process.env.REACT_APP_FRONTEND_URL || 'https://lopeglad.no';

/** Optional numeric program id when known (skips slug resolution in app). */
export const LOP30_PROGRAM_ID = process.env.REACT_APP_LOP30_PROGRAM_ID || '';

export function getLop30ProgramDeepLink() {
  if (LOP30_PROGRAM_ID) {
    return `lopeglad://programs/${LOP30_PROGRAM_ID}`;
  }
  return `lopeglad://program/${LOP30_PROGRAM_SLUG}`;
}

export function getLop30ProgramUniversalUrl() {
  if (LOP30_PROGRAM_ID) {
    return `${frontendBase}/programs/${LOP30_PROGRAM_ID}`;
  }
  return `${frontendBase}/program/${LOP30_PROGRAM_SLUG}`;
}
